

import { Link } from 'react-router-dom'
import img7 from '../images/blog/blog-07.jpg'
import img16 from '../images/blog/blog-08.png'
import img9 from '../images/blog/blog-09.jpg'
import img10 from '../images/blog/blog-10.jpg'
import img11 from '../images/blog/blog-11.jpg'
import img12 from '../images/blog/blog-12.jpg'
import img13 from '../images/blog/blog-13.jpg'
import img14 from '../images/blog/blog-14.jpg'
import img15 from '../images/blog/blog-15.jpg'
import img8 from '../images/blog/blog-16.jpg'
import img17 from '../images/blog/blog-17.jpg'
import img18 from '../images/blog/blog-18.jpg'

const dataBlog = [
    {
        img: img13,
        category: 'Aliwen - Mixta compartida',
        title: 'Habitación compartida, climatizada, con vista a la ciudad, lampara y enchufe en cada unidad.',
        links: '/aliwen'
    },
    {
        img: img17,
        category: 'Killa - Doble superior',
        title: 'Habitación con cama doble, cuenta con aire acondicionado, calefacción, TV, y vistas a la ciudad.',
        links: '/killa'
    },
    {
        img: img11,
        category: 'Wayiki - Doble Simple',
        title: 'Habitación doble con litrera, acceso directo a la terraza, y vistas a la ciudad.',
        links: '/wayiki'
    },
    {
        img: img16,
        category: 'Wayta - Triple Superior',
        title: 'Habitación con 1 cama doble y 1 individual, aire acondicionado, calefacción, TV. ',
        links: '/wayta'
    },
    {
        img: img10,
        category: 'Sami - Compartida Femenina',
        title: 'Habitacion compartida solo para mujeres, con acceso directo a la terraza y vistas a la ciudad.',
        links: '/sami'
    },
    {
        img: img14,
        category: 'Nina - Doble Simple',
        title: 'Habitación con una cama doble, con acceso al salón y zona de comedor al aire libre',
        links: '/nina'
    },
    {
        img: img12,
        category: 'Inti - Triple Simple',
        title: 'Habitación con cama individual y una litera, con aire acondicionado, calefacción y vistas al patio interno.',
        links: '/inti'
    },
    {
        img: img9,
        category: 'Amaru - Doble Simple',
        title: 'Habitación doble en litera, acceso al salón, zona de comedor al aire libre y vistas a la ciudad.  ',
        links: '/amaru'
    },
    {
        img: img15,
        category: 'Chaski - Cuadruple',
        title: 'Habitación con 1 cama doble y 1 litera, acceso directo a la terraza y vistas a la ciudad.  ',
        links: '/chaski'
    },
    {
        img: img7,
        category: 'Pacha - Cuadruple superior',
        title: 'Habitación con 1 cama doble y 1 litera, aire acondicionado, calefacción, TV,  vistas a la piscina y acceso directo a la terraza.',
        links: '/pacha'
    },
    {
        img: img18,
        category: 'Shangu - Familiar',
        title: ' Habitación con 1 cama doble Queen y 2 literas, baño privado, aire acondicionado, calefacción, TV, y vistas a la piscina. ',
        links: '/shangu'
    },

]

export default dataBlog;